import axios from "axios";
import { useQuery } from "react-query";
import { useInView } from "react-intersection-observer";

export const useAggrEventFlows = ({
  contentType,
  idValuePath,
  eventNameValuePath,
  orderIdxValuePath,
  timeValuePath,
  activeFilters = [],
  findQuery,
  queryOptions = {},
  vizCardId,
  enableVisibilityFetching = false,
}) => {

  const { ref, inView } = useInView({
    triggerOnce: true,
    skip: !enableVisibilityFetching,
  });

  const body = {
    contentType,
    idValuePath,
    eventNameValuePath,
    orderIdxValuePath,
    timeValuePath,
    activeFilters,
    findQuery,
  };

  const endpoint = `/api/insightMatrix/aggrEventFlows`;

  const serializedBody = JSON.stringify(body);

  const shouldFetch = enableVisibilityFetching ? inView : true;

  const result = useQuery({
    queryKey: ["useAggrEventFlows", vizCardId, serializedBody],
    queryFn: () =>
      axios
        .post(endpoint, body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((data) => data.data),
    ...queryOptions,
    enabled: (queryOptions.enabled !== false) && shouldFetch,
  });

  const isWaitingForVisibility = enableVisibilityFetching && !inView;
  const effectiveStatus = isWaitingForVisibility ? "loading" : result.status;

  return {
    ...result,
    status: effectiveStatus,
    ref: enableVisibilityFetching ? ref : undefined,
  };
};
